<template>
  <div class="uploading">
    上傳中...
  </div>
</template>
<script>
export default {
  name: 'Uploading'
}
</script>
<style lang="scss" scoped>
.uploading {
  fill: $secondaryColor;
  width: 140px;
}
</style>
